import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IconArrowLeft, IconGenderMale, IconGenderFemale, IconGenderAgender } from "@tabler/icons-react";
import { addAthlete } from "../../db"; // Import Dexie.js functions
import { useNavigate } from "react-router-dom";
import EditEvent from "../../Components/EditForms/Event";


const New = () => {

    const { t } = useTranslation();

    return (
        <div className="p-4 flex flex-col h-full relative">
            <div className="flex items-center pb-4 w-full">
                <div className="shrink-0 w-10">
                    <Link to="/events">
                        <IconArrowLeft className="w-6 h-auto" />
                        <span className="sr-only">{t("events.backToList")}</span>
                    </Link>
                </div>
                <h1 className="grow text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0">{t("events.newEvent")}</h1>
                <div className="shrink-0 w-10"></div>
            </div>

            <div className="grow overflow-y-auto overflow-x-hidden">
                <EditEvent />
            </div>
        </div>
    );
};

export default New;